import { render, staticRenderFns } from "./rolePermission.vue?vue&type=template&id=8496d8d4&scoped=true"
import script from "./rolePermission.vue?vue&type=script&lang=js"
export * from "./rolePermission.vue?vue&type=script&lang=js"
import style0 from "./rolePermission.vue?vue&type=style&index=0&id=8496d8d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8496d8d4",
  null
  
)

export default component.exports